"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require("babel-runtime/core-js/object/get-prototype-of");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require("babel-runtime/helpers/possibleConstructorReturn");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require("babel-runtime/helpers/inherits");

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _glamor = require("glamor");

var _reactRouter = require("react-router");

var _Icon = require("@quixeltools/quixel-ui-library/dist/components/common/website/Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _css = require("@quixeltools/quixel-ui-library/dist/utils/css");

var _polyfluid = require("@quixeltools/quixel-ui-library/dist/utils/polyfluid");

var _Tooltip = require("@quixeltools/quixel-ui-library/dist/components/common/essentials/Tooltip");

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _fonts = require("@quixeltools/quixel-ui-library/dist/utils/fonts");

var _components = require("components");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vidLink = (0, _glamor.css)({
  position: "absolute",
  display: "flex",
  alignItems: "center",
  width: "50vw",
  height: "30vw",
  margin: "auto",
  cursor: "pointer",
  left: "50%",
  marginLeft: "-25vw",
  top: "100px"
}, (0, _css.maxWidth)(_css.breakpoints.xlarge)({
  width: "72vw",
  marginLeft: "-36vw",
  height: "40vw"
}), (0, _css.maxWidth)(_css.breakpoints.large)({
  width: "81vw",
  marginLeft: "-40vw",
  height: "45vw"
}));
var wrap = function wrap(bg) {
  return (0, _glamor.css)((0, _css.bgCover)(bg), {
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
    width: "100%",
    height: "42.2vw"
  }, (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
    height: "50vw"
  }), (0, _css.maxWidth)(_css.breakpoints.large)({
    height: "auto",
    padding: "6em 1.5em"
  }));
};

var inner = (0, _glamor.css)({
  position: "relative",
  textAlign: "center",
  color: _css.colors.white,
  width: "100%",
  zIndex: 1
});

var title = (0, _glamor.css)(_fonts.H1, {
  margin: "auto",
  maxWidth: "1280px",
  marginBottom: "1rem",
  textTransform: "uppercase"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  marginBottom: "2px",
  lineHeight: 1.1
}));

var subTitle = (0, _glamor.css)(_fonts.subH1, {
  maxWidth: "1280px",
  margin: "auto",
  marginBottom: "3.125rem"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  lineHeight: 1.3
}));
var artist = (0, _glamor.css)(_fonts.p4, {
  letterSpacing: "0.8px",
  position: "absolute",
  right: (0, _css.unitRem)(1.33),
  bottom: (0, _css.unitRem)(1.33),
  textTransform: "uppercase"
});

var link = function link(icon) {
  return (0, _glamor.css)(_fonts.p3, {
    color: _css.colors.white,
    fontWeight: 400,
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    textDecoration: "none",
    lineHeight: 0,
    letterSpacing: "-0.25px",
    // '&:hover svg':{
    //   stroke:'#fff !important',
    //   fill: '#fff !important',
    // },

    transition: "transform " + _css.time.fast,
    "& svg": {
      transform: icon && "rotate(270deg)",
      marginLeft: "0.5rem",
      transition: "color 0.2s",
      stroke: "#fff !important",
      fill: "#fff !important"
    },
    ":hover": {
      color: "white",
      "& svg": {
        color: "white"
      }
    },
    "& a": {
      textTransform: "capitalize"
    }
  });
};

var linkContainer = (0, _glamor.css)({
  transition: "transform " + _css.time.fast,
  ":hover": {
    transform: "translateY(-2px)"
  },
  ":active": {
    transform: "translateY(0)",
    transition: "none"
  }
});

var HerosuperHeading = (0, _glamor.css)(_fonts.superH1, {
  color: _css.colors.blue,
  textTransform: "uppercase",
  marginBottom: (0, _css.unitRem)(2)
}, (0, _polyfluid.polyfluid)({
  marginBottom: {
    small: [2, 2.25],
    medium: 2.25,
    large: [2.25, 3]
  }
}));
var btn = (0, _glamor.css)(_fonts.Btn, {
  display: "inline-block",
  margin: "auto",
  whiteSpace: "nowrap"
});

var superIcon = function superIcon(url) {
  return (0, _glamor.css)((0, _css.bgContain)(url), {
    width: "14rem",
    height: "14rem",
    display: "inline-block",
    marginBottom: "5rem"
  }, (0, _css.maxWidth)(_css.breakpoints.super4k)({
    width: "12rem",
    height: "12rem"
  }), (0, _css.maxWidth)(_css.breakpoints.xxxlarge)({
    width: "12rem",
    height: "6.5rem",
    marginBottom: "2.5rem"
  }), (0, _css.maxWidth)(_css.breakpoints.xxlarge)({
    width: "12rem",
    height: "6.5rem"
  }), (0, _css.maxWidth)(_css.breakpoints.xlarge)({
    width: "12rem",
    height: "5.7rem",
    marginBottom: "1.5rem"
  }), (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    width: "8rem",
    height: "4rem"
  }));
};
var messageText = (0, _glamor.css)(_fonts.p4, {
  letterSpacing: "0.8px",
  textTransform: "uppercase",
  position: "absolute",
  bottom: "15px",
  left: "0",
  width: "100%",
  textAlign: "center",
  color: "#ddd"
}, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
  fontSize: "0.65rem"
}));

var postion = (0, _glamor.css)({
  zIndex: 0
});
var button = function button(lable) {
  return (0, _glamor.css)({
    margin: 20
  }, (0, _css.maxWidth)(_css.breakpoints.mediumlarge)({
    display: "inline-block"
  }));
};

var bgVidStyle = (0, _glamor.css)({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  minWidth: "100%",
  minHeight: "100%"
});

var renderButton = function renderButton(label, to, mode, toolTip, onClickHandler) {
  if (!label) return null;

  var toStr = to.pathname ? to.pathname : to;
  return toStr.startsWith("/") ? _react2.default.createElement(_components.ButtonLibrary, (0, _extends3.default)({
    className: button(label)
  }, btn, {
    to: to,
    mode: mode,
    label: label,
    onClick: onClickHandler,
    toolTip: toolTip
  })) : _react2.default.createElement(_components.ButtonLibrary, (0, _extends3.default)({
    className: button(label)
  }, btn, {
    href: to,
    mode: mode,
    label: label,
    onClick: onClickHandler,
    toolTip: toolTip,
    rel: "noreferrer"
  }));
};
var loadYT = void 0;

var Hero = function (_React$Component) {
  (0, _inherits3.default)(Hero, _React$Component);

  function Hero(props) {
    (0, _classCallCheck3.default)(this, Hero);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Hero.__proto__ || (0, _getPrototypeOf2.default)(Hero)).call(this, props));

    _this.state = {
      playing: false,
      player: null
    };
    _this.onClickVideo = _this.onClickVideo.bind(_this);
    _this.onCloseVideo = _this.onCloseVideo.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Hero, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.bgVid) {
        this.bgVid.play();
      }
      if (this.youtubePlayerAnchor) {
        var YTid = this.props.YTid;
        var elm = this.youtubePlayerAnchor;
        var checkYT = setInterval(function () {
          if (window.YT) {
            //...setup video here using YT.Player()
            try {
              this.setState({
                player: new window.YT.Player(elm, {
                  height: "100%",
                  width: "100%",
                  videoId: YTid
                })
              });
              clearInterval(checkYT);
            } catch (e) {}
          }
        }.bind(this), 100);
      }
    }
  }, {
    key: "onClickVideo",
    value: function onClickVideo() {
      if (!this.state.playing) {
        if (this.state.player) {
          this.state.player.playVideo();
          //this.state.player.playVideo();
        }
        this.setState({ playing: true });
      }
    }
  }, {
    key: "onCloseVideo",
    value: function onCloseVideo() {
      if (this.state.playing) {
        if (this.state.player) {
          this.state.player.stopVideo();
        }
        this.setState({ playing: false });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var backgroundVideo = props.backgroundVideo;


      return _react2.default.createElement(
        "section",
        {
          className: (0, _glamor.css)(wrap(props.bg, props.position), props.className),
          onClick: this.onCloseVideo },
        _react2.default.createElement("div", {
          className: (0, _glamor.css)(postion, props.darkerOverlyBottom ? (0, _css.darkOverlayToBottom)() : (0, _css.darkOverlay)(props.opacity ? props.opacity : 0), { zIndex: 1 })
        }),
        backgroundVideo && _react2.default.createElement(
          "video",
          {
            ref: function ref(r) {
              _this2.bgVid = r;
            },
            className: bgVidStyle,
            poster: backgroundVideo.poster,
            loop: backgroundVideo.loop,
            autoPlay: "autoplay",
            id: "vid",
            muted: "true",
            playsInline: "true" },
          _react2.default.createElement("source", { src: backgroundVideo.src, type: "video/mp4" })
        ),
        _react2.default.createElement(
          "div",
          { className: inner },
          props.superIconUrls && props.superIconUrls.map(function (_superIcon) {
            return _react2.default.createElement("span", (0, _extends3.default)({}, superIcon(_superIcon), { key: _superIcon }));
          }),
          props.superTitles && props.superTitles.map(function (_superTitle) {
            return _react2.default.createElement(
              "p",
              (0, _extends3.default)({}, HerosuperHeading, { key: _superTitle }),
              _superTitle
            );
          }),
          _react2.default.createElement("h1", { className: title, dangerouslySetInnerHTML: { __html: props.title } }),
          _react2.default.createElement("h3", (0, _extends3.default)({}, subTitle, { dangerouslySetInnerHTML: { __html: props.subTitle } })),
          !props.YTid && _react2.default.createElement(
            "div",
            null,
            renderButton(props.secondaryLabel, props.secondaryTo, "secondary", props.btnTooltip, props.onClickSecondaryHandler),
            renderButton(props.primaryLabel, props.primaryTo, "secondary", null, props.onClickPrimaryHandler),
            renderButton(props.transparentLabel, props.transparentTo, "transparentWithWhiteBorder", null, props.transparentClickHandler)
          ),
          props.YTid && _react2.default.createElement(
            "div",
            null,
            renderButton(props.secondaryLabel, "", "secondary", null, this.onClickVideo),
            _react2.default.createElement(
              "div",
              {
                style: {
                  position: "fixed",
                  zIndex: 999999,
                  width: "100vw",
                  height: "100vh",
                  top: 0,
                  left: 0,
                  background: "rgba(0,0,0,0.8)",
                  display: this.state.playing ? "" : "none"
                } },
              _react2.default.createElement(
                "div",
                { className: vidLink },
                _react2.default.createElement(
                  "div",
                  { style: { width: "100%", height: "100%" } },
                  _react2.default.createElement("div", {
                    ref: function ref(r) {
                      _this2.youtubePlayerAnchor = r;
                    } })
                )
              )
            )
          ),
          props.link && _react2.default.createElement(
            "div",
            { style: { marginTop: "3em" } },
            props.toolTip && _react2.default.createElement(
              _Tooltip2.default,
              {
                position: "bottom",
                onScrollDisable: props.onScrollDisable,
                message: props.toolTip },
              _react2.default.createElement(
                "div",
                { className: linkContainer },
                _react2.default.createElement(
                  _reactRouter.Link,
                  (0, _extends3.default)({}, props.link, { className: link(props.linkIcon === "rightSide") }),
                  props.link.label,
                  props.linkIcon && _react2.default.createElement(_Icon2.default, {
                    type: props.linkIcon,
                    width: 22,
                    height: 22,
                    color: "white",
                    viewBox: "0 0 52 52"
                  })
                )
              )
            ),
            !props.toolTip && _react2.default.createElement(
              "div",
              { className: linkContainer },
              _react2.default.createElement(
                _reactRouter.Link,
                (0, _extends3.default)({}, props.link, props.link.target && { rel: "noreferrer" }, {
                  className: link(props.linkIcon === "rightSide") }),
                props.link.label,
                props.linkIcon && _react2.default.createElement(_Icon2.default, {
                  type: props.linkIcon,
                  width: 22,
                  height: 22,
                  color: "white",
                  viewBox: "0 0 52 52"
                })
              )
            )
          )
        ),
        props.message && _react2.default.createElement("span", { className: messageText, dangerouslySetInnerHTML: { __html: props.message } }),
        props.artist && _react2.default.createElement(
          "div",
          { className: artist },
          props.artist
        )
      );
    }
  }]);
  return Hero;
}(_react2.default.Component);

Hero.defaultProps = { title2: "" };

exports.default = Hero;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Marketing/Hero/Hero.jsx
// module id = 1266
// module chunks = 0